import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { TradingOfferStatus } from '../../../types/TradingOffer';
import tradingOfferStatus from '../constants/tradingOfferStatus';

export enum TradingOfferStatusBadgeVariant {
  BADGE = 'badge', // eslint-disable-line no-unused-vars
  TEXT = 'text', // eslint-disable-line no-unused-vars
}

type TradingOfferStatusBadgeProps = {
  status: TradingOfferStatus;
  variant?: TradingOfferStatusBadgeVariant;
};

const TradingOfferStatusBadge: FC<TradingOfferStatusBadgeProps> = ({
  status,
  variant = TradingOfferStatusBadgeVariant.BADGE,
}) => {
  const { t } = useTranslate();

  const currentStatus = tradingOfferStatus[status];

  const badgeClasses = {
    [TradingOfferStatusBadgeVariant.BADGE]: `badge ${currentStatus.badge} fs-11px mx-1`,
    [TradingOfferStatusBadgeVariant.TEXT]: `${currentStatus.style} fw-medium d-inline`,
  };

  const iconClasses = {
    [TradingOfferStatusBadgeVariant.BADGE]: `icon ni ${currentStatus.icon} lh-18px`,
    [TradingOfferStatusBadgeVariant.TEXT]: `icon ni ${currentStatus.icon} mr-1`,
  };

  return (
    <span className={badgeClasses[variant]}>
      <em className={iconClasses[variant]} />
      <span>{t(currentStatus.label)}</span>
    </span>
  );
};

export default TradingOfferStatusBadge;
